import { createMuiTheme } from '@material-ui/core';
import { DEFAULT_THEME, GLOBAL_FONT_THEME } from 'theme/CommonTheme';

const defaultTheme = DEFAULT_THEME;
export default createMuiTheme({
    overrides: {
        MuiBadge: {
            badge: {
                fontWeight: 1000
            },
            colorPrimary: {
                color: '#000000',
                backgroundColor: '#ffc107'
            }
        },
        MuiToolbar: {
            regular: {
                minHeight: 54,
                font: 'inherit',
                [defaultTheme.breakpoints.up('sm')]: {
                    minHeight: '55px !important'
                },
                [defaultTheme.breakpoints.down('md')]: {
                    minHeight: '20px',
                    fontSize: '10px'
                }
            },
            gutters: {
                paddingLeft: '16px !important',
                paddingRight: '0 !important'
            }
        },
        MuiSvgIcon189: {
            root: {
                width: '1em !important',
                height: '1em !important'
            }
        },
        MuiDrawer: {
            paper: {
                zIndex: 1200,
                height: 'calc(100vh - 55px)'
            },
            root: {
                position: 'inherit!important'
            },
            paperAnchorLeft: {
                width: 270,
                padding: 5,
                backgroundColor: '#fafafa',
                top: '55px'
            }
        },
        MuiBackdrop: {
            root: {
                zIndex: '120',
                backgroundColor: '#00000000!important'
            }
        },
        MuiAppBar: {
            colorPrimary: {
                backgroundColor: '#00437b'
            },
            root: {
                paddingRight: '0 !important',
                zIndex: '1200 !important'
            }
        },
        MuiIconButton: {
            root: {
                outline: 'none !important'
            }
        },
        MuiButtonBase: {
            root: {
                outline: 'none !important'
            }
        }
    },
    typography: GLOBAL_FONT_THEME
});

export const SIDEBAR_THEME_ICON = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiBadge: {
            badge: {
                fontWeight: 1000
            },
            colorPrimary: {
                color: '#000000',
                backgroundColor: '#ffc107'
            }
        },
        MuiListItem: {
            gutters: {
                padding: 12,
                fontSize: '14px !important'
            }
        },
        MuiListItemText: {
            primary: {
                color: '#154e8f',
                marginLeft: 10
            }
        },
        MuiSvgIcon189: {
            root: {
                width: '24px !important',
                height: '24px !important'
            }
        },
        MuiAvatar: {
            root: {
                width: '24px !important',
                height: '24px !important'
            },
            colorDefault: {
                backgroundColor: 'none',
                color: '#7b7a86'
            }
        },
        MuiTypography: {
            body1: {
                fontWeight: '600!important'
            }
        }
    }
});

export const BOTTOMBAR_THEME_ICON = createMuiTheme({
    typography: GLOBAL_FONT_THEME,
    overrides: {
        MuiBadge: {
            badge: {
                fontWeight: 1000
            },
            colorPrimary: {
                color: '#000000',
                backgroundColor: '#ffc107'
            }
        },
        MuiListItem: {
            gutters: {
                padding: 6,
                fontSize: '14px !important'
            }
        },
        MuiListItemText: {
            primary: {
                color: '#154e8f',
                marginLeft: 10
            }
        },
        MuiAvatar: {
            root: {
                width: '24px !important',
                height: '24px !important'
            },
            colorDefault: {
                backgroundColor: 'none'
            }
        },
        MuiTypography: {
            body1: {
                fontWeight: '600!important'
            }
        }
    }
});
